<template>
    <div class="upload-wrapper">
        <div v-if="label" class="upload-label">{{ label }}</div>
        <div :class="{'upload-content-padding': label}">
            <input multiple :accept="accepted" @change="fileChange" class="file-input" ref="fileInput" type="file" />
            <template v-if="!uploadInProgress">
                <v-btn @click="uploadClick" depressed icon v-if="!readonly">
                    <v-icon small>fa-upload</v-icon>
                </v-btn>
            </template>
            <div @dragover.prevent @drop.prevent="dropFiles" class="files-drop" v-cloak v-if="!readonly">
                <v-icon small>fas fa-copy</v-icon>
                {{ $t('labels.dragdropMultiple') }}
            </div>
            <div v-if="uploadInProgress">
                {{ $t('labels.uploadInProgress') }}
            </div>
            <div class="files-container" v-if="uploadedFiles.length > 0">
                <div class="files-container-item" v-for="(file, key) in uploadedFiles" :key="key">
                    <v-btn @click="downloadClick(key)" depressed icon>
                        <v-icon small>fa-download</v-icon>
                    </v-btn>
                    <v-btn @click="deleteClick(key)" depressed icon v-if="!readonly">
                        <v-icon small>fa-trash</v-icon>
                    </v-btn>
                    {{ file.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.file-input {
    display: none;
}
.files-drop {
    border: 1px solid #d5d5d5;
    padding: 10px;
    width: 100%;
    height: 40px;
    max-width: 200px;
    text-align: center;
    display: inline-block;
}
.files-container {
    margin-top: 10px;
    width: 100%;
    max-width: 400px;
}

.files-container-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.files-container-item:hover {
    background: #f5f5f5;
}

.upload-wrapper {
    border-radius: 4px;
    border: 1px solid #9e9e9e;
    padding: 10px;
    margin-top: 3px;
}

.upload-wrapper:hover {
    border: 1px solid #242424;
}

.upload-label {
    left: 0;
    top: -22px;
    height: 15px;
    line-height: 15px;
    padding-left: 2px;
    padding-right: 2px;
    font-size: 13px;
    font-weight: 400;
    position: relative;
    background: white;
    display: inline-block;
}

.upload-content-padding {
    margin-top: -20px;
}
</style>

<script>
export default {
    name: 'Upload',
    props: ['value', 'accept', 'readonly', 'label'],
    components: {},
    data() {
        return {
            uploadedFiles: [],
            uploadInProgress: false,
            accepted: '',
            remainingUploadsCounter: 0
        };
    },
    watch: {
        value: function () {
            this.uploadedFiles = this.$props.value;
        }
    },
    methods: {
        dropFiles(dropped) {
            if (!this.readonly) {
                this.uploadFiles(dropped.dataTransfer.files);
            }
        },
        uploadClick() {
            this.$refs.fileInput.click();
        },
        fileChange() {
            this.uploadFiles(this.$refs.fileInput.files);
        },
        uploadFiles(files) {
            this.uploadInProgress = true;
            this.remainingUploadsCounter = files.length;
            let vm = this;
            for (let file of files) {
                this.$APIUpload(file, (data) => {
                    if (data['success']) {
                        vm.uploadedFiles.push(data['file']);
                        if (--vm.remainingUploadsCounter === 0) {
                            vm.uploadInProgress = false;
                            vm.$emit('input', vm.uploadedFiles);
                        }
                    }
                });
            }
        },
        downloadClick(fileIndex) {
            window.open(this.uploadedFiles[fileIndex].link);
        },
        deleteClick(fileIndex) {
            var vm = this;
            this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
                if (result) {
                    vm.uploadedFiles.splice(fileIndex, 1);
                    vm.$emit('input', vm.uploadedFiles);
                }
            });
        }
    },
    mounted() {
        if (this.accept !== undefined) {
            this.accepted = this.accept;
        }
        this.uploadedFiles = this.$props.value;
    }
};
</script>
